import React, { useEffect } from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';
import { useDispatch, useSelector } from 'hooks/store';
import { cleanUsersAction, getUsersListAction, remoteTotalSelector } from 'state/slices/users';
import { usePagination } from 'hooks/pagination';
import { PaginationData, UserCommon } from 'constants/interface';

import {
  DetailPage,
  ListPage,
} from './pages';

const ViewPage = (): JSX.Element => {
  const { path } = useRouteMatch();
  const dispatch = useDispatch();
  const remoteTotal = useSelector(remoteTotalSelector);

  const remoteFetch = (
    paginationData: PaginationData,
  ) => {
    dispatch(getUsersListAction(paginationData));
  };
  const pagination = usePagination<UserCommon>(
    remoteFetch,
  );

  useEffect(() => {
    dispatch(cleanUsersAction());
  }, []);

  useEffect(() => {
    pagination.updateTotal(remoteTotal);
  }, [remoteTotal]);

  return (
    <Switch>
      <Route path={`${path}${ROUTES.dashboard.users.detail.root}`} render={() => <DetailPage onUpdateFinish={pagination.fetch} />} />
      <Route path={`${path}`} render={() => <ListPage pageData={pagination.getInternal()} onTableChange={pagination.onTableChange} onSearch={pagination.onSearch} />} />
    </Switch>
  );
};

export default ViewPage;
